import {ResolveFn} from '@angular/router';
import {ROUTE_TITLES} from '../../assets/config/titles.config';

export const titleResolver: ResolveFn<string> = (route) => {
  const routeName = route.data['titleKey'];
  // @ts-ignore
  return ROUTE_TITLES[routeName] || 'Verwaltung';
};
